import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.51565 1.50024H9.5C9.77614 1.50024 10 1.7241 10 2.00024C10 2.27639 9.77614 2.50024 9.5 2.50024H7.84647L5.22147 9.50024H7C7.27614 9.50024 7.5 9.7241 7.5 10.0002C7.5 10.2764 7.27614 10.5002 7 10.5002H4.50509C4.50166 10.5003 4.49823 10.5003 4.49479 10.5002H2.5C2.22386 10.5002 2 10.2764 2 10.0002C2 9.7241 2.22386 9.50024 2.5 9.50024H4.15347L6.77847 2.50024H5C4.72386 2.50024 4.5 2.27639 4.5 2.00024C4.5 1.7241 4.72386 1.50024 5 1.50024H7.48452C7.49487 1.49992 7.50525 1.49992 7.51565 1.50024Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.021 2.00033H12.6667C13.0349 2.00033 13.3334 2.2988 13.3334 2.66699C13.3334 3.03518 13.0349 3.33366 12.6667 3.33366H10.462L6.96205 12.667H9.33342C9.7016 12.667 10.0001 12.9655 10.0001 13.3337C10.0001 13.7018 9.7016 14.0003 9.33342 14.0003H6.00686C6.00229 14.0004 5.99771 14.0004 5.99313 14.0003H3.33341C2.96522 14.0003 2.66675 13.7018 2.66675 13.3337C2.66675 12.9655 2.96522 12.667 3.33341 12.667H5.53804L9.03804 3.33366H6.66675C6.29856 3.33366 6.00008 3.03518 6.00008 2.66699C6.00008 2.2988 6.29856 2.00033 6.66675 2.00033H9.97944C9.99324 1.99989 10.0071 1.99989 10.021 2.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.526 2.50041H15.8333C16.2935 2.50041 16.6666 2.8735 16.6666 3.33374C16.6666 3.79398 16.2935 4.16707 15.8333 4.16707H13.0774L8.70237 15.8337H11.6666C12.1268 15.8337 12.4999 16.2068 12.4999 16.6671C12.4999 17.1273 12.1268 17.5004 11.6666 17.5004H7.5084C7.50268 17.5005 7.49696 17.5005 7.49123 17.5004H4.16659C3.70635 17.5004 3.33325 17.1273 3.33325 16.6671C3.33325 16.2068 3.70635 15.8337 4.16659 15.8337H6.92237L11.2974 4.16707H8.33325C7.87301 4.16707 7.49992 3.79398 7.49992 3.33374C7.49992 2.8735 7.87301 2.50041 8.33325 2.50041H12.4741C12.4914 2.49987 12.5087 2.49986 12.526 2.50041Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 1.5C9.77614 1.5 10 1.72386 10 2C10 2.27614 9.77614 2.5 9.5 2.5H7.84668L5.22168 9.5H7C7.27614 9.5 7.5 9.72386 7.5 10C7.5 10.2761 7.27614 10.5 7 10.5H2.5C2.22386 10.5 2 10.2761 2 10C2 9.72386 2.22386 9.5 2.5 9.5H4.15332L6.77832 2.5H5C4.72386 2.5 4.5 2.27614 4.5 2C4.5 1.72386 4.72386 1.5 5 1.5H9.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.6667 2C13.0349 2 13.3334 2.29848 13.3334 2.66667C13.3334 3.03486 13.0349 3.33333 12.6667 3.33333H10.4623L6.96232 12.6667H9.33342C9.7016 12.6667 10.0001 12.9651 10.0001 13.3333C10.0001 13.7015 9.7016 14 9.33342 14H3.33341C2.96522 14 2.66675 13.7015 2.66675 13.3333C2.66675 12.9651 2.96522 12.6667 3.33341 12.6667H5.53784L9.03784 3.33333H6.66675C6.29856 3.33333 6.00008 3.03486 6.00008 2.66667C6.00008 2.29848 6.29856 2 6.66675 2H12.6667Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8333 2.5C16.2935 2.5 16.6666 2.8731 16.6666 3.33333C16.6666 3.79357 16.2935 4.16667 15.8333 4.16667H13.0777L8.70272 15.8333H11.6666C12.1268 15.8333 12.4999 16.2064 12.4999 16.6667C12.4999 17.1269 12.1268 17.5 11.6666 17.5H4.16659C3.70635 17.5 3.33325 17.1269 3.33325 16.6667C3.33325 16.2064 3.70635 15.8333 4.16659 15.8333H6.92212L11.2971 4.16667H8.33325C7.87301 4.16667 7.49992 3.79357 7.49992 3.33333C7.49992 2.8731 7.87301 2.5 8.33325 2.5H15.8333Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconItalic01: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"italic-01"} {...props} />
);
